import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
import { ScrollProgress } from './ScrollProgress';
import { CookieBanner } from './CookieBanner';
import { ScrollToTop } from './ScrollToTop';
import { useSmoothScroll } from '@/hooks/useSmoothScroll';

/**
 * The shared chrome for every marketing route: header, footer, floating CTA,
 * scroll progress bar, cookie banner, and a skip-to-content anchor handled in index.html.
 */
export function PageShell() {
  useSmoothScroll(1000);
  return (
    <>
      <ScrollToTop />
      <ScrollProgress />
      <Header />
      <main id="main" className="min-h-[calc(100vh-4rem)]">
        <Outlet />
      </main>
      <Footer />
      <FloatingCTA />
      <CookieBanner />
    </>
  );
}
